import axiosInstance from "../Service/axiosConfig";

export const getProfileData = async ({ profileId, fullName }) => {
    try {
        const response = await axiosInstance.get(
            `/accounts/api/about/${profileId}/`
        );

        let profile_set_1 = { ...response.data.profile_set_1 };

        profile_set_1.name = fullName;

        profile_set_1.languages =
            profile_set_1.languages?.map(lang => lang.id) || [];

        profile_set_1.permanent_city =
            profile_set_1.permanent_city?.id || null;

        profile_set_1.present_city =
            profile_set_1.present_city?.id || null;

        profile_set_1.permanent_state =
            profile_set_1.permanent_state?.id || null;

        profile_set_1.present_state =
            profile_set_1.present_state?.id || null;

        return {
            profileSet1: profile_set_1,
            profileSet2: response.data.profile_set_2
        };
    } catch (error) {
        console.log(error);
        throw error;
    }
};
export const submitVerifiedProfile = async (data) => {
    const dataToSend = {
        surname: data.surname,
        name: data.name,
        email: data.email,
        gender: data.gender,
        dob: data.dob,
        present_address: data.present_address,
        permanent_address: data.permanent_address,
        govt_id_proof: data.govt_id_proof,
        present_state: data.present_state,
        present_city: data.present_city,
        permanent_state: data.permanent_state,
        permanent_city: data.permanent_city,
        mobile_number: data.mobile,
        status: data.status||null,
        comments: data.comments||null,
        is_celebrity:data?.is_celebrity||false
    };

    const formData = new FormData();

    Object.entries(dataToSend).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
            formData.append(key, value);
        }
    });

    const isFile = (value) =>
    value instanceof File || value instanceof Blob;

if (isFile(data.govt_id_proof_front_copy)) {
    formData.append(
        "govt_id_proof_front_copy",
        data.govt_id_proof_front_copy
    );
}

if (isFile(data.govt_id_proof_back_copy)) {
    formData.append(
        "govt_id_proof_back_copy",
        data.govt_id_proof_back_copy
    );
}


    const config = {
        headers: { "Content-Type": "multipart/form-data" }
    };

    if (data.id) {
        const res = await axiosInstance.patch(
            `/accounts/verified-profile/${data.id}/`,
            formData,
            config
        );
        return res.data;
    } else {
        const res = await axiosInstance.post(
            `/accounts/verified-profile/?profile_id=${data.profile_id}`,
            formData,
            config
        );
        return res.data;
    }
};

